module.exports = __webpack_public_path__ + "img/service-image.56b7d678.png";